import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ExportOptionsDialogComponent } from '../export-options-dialog/export-options-dialog.component';

@Component({
  selector: 'app-export-options',
  standalone: false,
  templateUrl: './export-options.component.html',
  styleUrls: ['./export-options.component.scss'],
})
export class ExportOptionsComponent {
  constructor(private dialog: MatDialog) {}

  openDialog(): void {
    this.dialog.open(ExportOptionsDialogComponent, {
      width: '43%',
      autoFocus: false,
    });
  }
}
